<mat-form-field class="soFormField" >


  <!--mat-select-header aria-label="selection header" class="selectheader" [ngClass]="setHeaderClass()" >{{label}}</mat-select-header>
  -->
  <mat-label>{{label}}</mat-label>
    <!--suppress AngularBindingTypeMismatch -->
  <mat-select [formControl]="dataFormCtrl" multiple #opts (openedChange)="searchCtrl.setValue('')"
    [matTooltip]="selectToolTip()"
    aria-label="select option">
    <!-- this is the select all box manually added -->
   
    <div class="checkbox-container">
      <mat-checkbox #allcheckbox color="primary" 
        [checked]="selectAllChecked(opts)" 
        [indeterminate]="selectAllIndeterminate(opts)"
        (change)="toggleSelection($event, opts, allcheckbox)" 
       
        [matTooltip]="selectAllToolTip(opts)"
        matTooltipPosition="above">
      </mat-checkbox>

      <mat-form-field class="searchInput" >
        <input
          matInput
          #input
          placeholder="search"
          title="search"
          [formControl]="searchCtrl"
          (keydown)="onSearchKeydown($event, input)"
        />
        <button type="button" *ngIf="searchCtrl && searchCtrl.value!==''" matSuffix aria-label="Clear" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

    </div>

    <mat-select-trigger [innerHTML]="selectDisplay()"></mat-select-trigger>


    <div class="options">
      <div *ngIf="searchCtrl && searchCtrl.value && !opts.options.length" class="no-data">
        No results found for "{{searchCtrl.value}}".
      </div>

      <mat-option *ngFor="let row of filteredOptions | async " [value]="row['key']"
        (onSelectionChange)="onSelectionChange($event)">{{row['value']}}</mat-option>
    </div>
  </mat-select>
  <button [style.border-width]="0" [style.margin-left]="'15px'" type="button" #clearButton *ngIf="dataFormCtrl.value && dataFormCtrl.value!.length > 0" matSuffix  aria-label="Clear" (click)="clearInput($event)">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>
